import * as React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { PercentageTextBoxEditor } from "../../../../../../../react-core/Html/PercentageTextBoxEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { addMonths } from "../../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { Indexation as IndexationEntity } from "../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/Indexation";
import { IndexationEffectiveDateType } from "../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/IndexationEffectiveDateType";
import { IndexationType } from "../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/IndexationType";
import { ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { datePickerOptions } from "../../Resource/Contents";
interface IIndexationProps {
    firstPaymentDate: Date;
    data: IndexationEntity;
    onChange: (indexaton: IndexationEntity) => void;
    onRef: (ref) => void;
}

interface IIndexationState {}

export class Indexation extends ProcessComponent<IIndexationProps, IIndexationState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { onChange, data } = this.props;

        return (
            <>
                <div className="row">
                    <div className="col-sm-4 col-12">
                        <SelectEditor
                            options={[null, IndexationType.AverageWeeklyEarning, IndexationType.FixedPercentage]}
                            getText={(v) =>
                                v == null
                                    ? "No indexation (0% index)"
                                    : v == IndexationType.AverageWeeklyEarning
                                    ? "Average weekly earnings"
                                    : "User defined percentage"
                            }
                            selected={data?.IndexationType}
                            label="Indexation"
                            onChange={(v) => {
                                if (v == null) {
                                    this.props.onChange(null);
                                } else {
                                    if (data == null) {
                                        onChange({
                                            IndexationType: v,
                                            EffectiveDateType: IndexationEffectiveDateType.AnniversaryDate,
                                        });
                                    } else {
                                        data.IndexationType = v;
                                        onChange(data);
                                    }
                                }
                            }}
                        />
                    </div>
                    {data?.IndexationType == IndexationType.FixedPercentage && (
                        <div className="col-sm-4 col-12">
                            <PercentageTextBoxEditor
                                value={data?.Percentage}
                                label={"Percentage"}
                                required={"Please enter percantage"}
                                maxNumberOfDecimalPlaces={{ errorMessage: "only allow two decimal places", value: 2 }}
                                moreThan={{ errorMessage: "percentage must between 1 and 10", value: 0 }}
                                atMost={{ errorMessage: "percentage must between 1 and 10", value: 10 }}
                                onChange={(v) => {
                                    data.Percentage = v;
                                    onChange(data);
                                }}
                            />
                        </div>
                    )}
                </div>
                {data?.IndexationType !== null && data?.IndexationType !== undefined && (
                    <div className="row">
                        <div className="col-sm-4 col-12">
                            <SelectEditor
                                options={[
                                    IndexationEffectiveDateType.AnniversaryDate,
                                    IndexationEffectiveDateType.FixedDate,
                                ]}
                                getText={(v) =>
                                    v == IndexationEffectiveDateType.AnniversaryDate
                                        ? "On anniversary date"
                                        : "On a user specified date"
                                }
                                onChange={(v) => {
                                    data.EffectiveDateType = v;
                                    onChange(data);
                                }}
                                selected={data?.EffectiveDateType}
                                label={"Recalculation date type"}
                                required="Please selected recalculation date type"
                            />
                        </div>
                        {data?.EffectiveDateType == IndexationEffectiveDateType.FixedDate && (
                            <div className="col-sm-4 col-12">
                                <DatePicker
                                    selected={JsonDateParser.toDateNoOffset(data?.EffectiveDate)}
                                    label="First automatic increase date"
                                    {...datePickerOptions}
                                    alwaysValidateOnUpdate={true}
                                    moreThan={{
                                        errorMessage:
                                            "The user specific renewal date selected must not be within 3 months of the start date of the payments",
                                        value: addMonths(this.props.firstPaymentDate || new Date(), 3),
                                    }}
                                    required="Please enter first automatic increase date"
                                    onChange={(v) => {
                                        data.EffectiveDate = JsonDateParser.toJsonDateNoOffset(v);
                                        onChange(data);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                )}
            </>
        );
    }
}
